export function init(slug?: string): void {
	if (document.getElementById('id_lb-project-detail')) {
		import('./view')
			.then(mod => (new mod.ProjectDetailView(slug)));
	}
}
